//-*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// MUI
import {  withStyles } from "@material-ui/core/styles"

// D3
import * as d3 from "d3" 

import * as _ from "lodash"

// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashBar2Chart>")


const styles = theme => ({
//    sheet_old: {
//        margin: 0,
//        padding: 0,
//        borderWidth: "0.3em",
//        borderStyle: "dotted",
//        borderColor: "grey",
//    },
    chartDiv: {
        position: "relative",
        width: "100%", // this is working
        height: "100%",
        margin: 0,
        padding: 0,
        // borderWidth: "4px", // we set that as a prop
        borderStyle: "dotted",
        borderColor: "grey",
        // backgroundColor: "#f7f6f6"
        backgroundColor: "white", // color inside the
        "& :hover": {
            // backgroundColor: "black" // color inside the
        }
    },
    chartSvg: {
        margin: 0,
        padding: 0,

    },
    
    circleExample: {
        r: 50,
        cx: 50,
        cy: 50
    },

    removed: {
        display: "none"
    },

    xAxis: {
        '& path': {
            display: "none"
        }
    },

    yAxis: {
        '& path': {
            display: "none"
        }
    },

    bar1: {
        fill: "#438CFF"
    },

    bar1Rect: {
        fill: "none",
        // stroke: "grey",
        stroke: "#9e9e9e",
        strokeWidth: "0.2px"
    },

    mark1: {
        // fill: "grey",
        // fill: "#f2f2f2",
        // fill: "grey",
        //stroke: "black",
        // fill: "grey",
        // fill: "#9e9e9e", // grey same as button
        // fill: "#438CFF", // blue, same as main color
        // fill: "#7F8250", // brown, goes well with gree
        // fill: "#D3A350",
        fill: "#3E4A3D",
        opacity: 0.5,
        strokeWidth: "1px",
    },
    
    bar2: {
        fill: "#006EDD",
        opacity: 0.5
    },

    bar3: {
        // fill: "#43a047", // green
        //fill: "#28C195",
        // fill: "#8DF48A", too light
        // fill: "#008A62",
        fill: "#7db47b", // pale gree
        // opacity: 0.5
        opacity: 1
    },


    bar3Negative: {
        // fill: "#c3a875",
        // fill: "#FFDA84",
        // opacity: 0.5
        fill: "#ffeb3b",
        opacity: 1
    },


    marker1: {
    },

    listener: {
        fill: "transparent",
    },

    //
    //  tooltip stuff
    //
    tooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
    },

    tooltipAnchor_old: {
//        content: '',
        position: "relative",
        bottom: "-9px",
        left: "50%",
        width: "12px",
        height: "12px",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        transform: "translate(-50%, 50%) rotate(45deg)",
        transformOrigin: "center center",
        zIndex: 10
    },

    tooltipAnchor: {
        position: "absolute",
        width: "12px",
        height: "12px",
        bottom: "-0",
        left: "50%",
        transform: "translate(-50%, 50%) rotate(45deg)",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        // backgroundColor: "red",
        // transformOrigin: "center center", // we don't need this
    },

//    killTransition: {
//        transition: "sdf!importantxo"
//    }

    killTransition: {
        // display is not really a transition, but
        // by specifying it here, we're killing the "all
        // in the externalTooltip that has the transition
        // for the cases outside this
        transition: "display 0.2s ease-out !important"
    }
    
})

class DashBar2Chart extends Component {

    static defaultProps = {
        showBar1: true,
        showBar2: true,
        showBar3: false,
        showMark1: false,
        bar1Spacing: 10,
        bar2Spacing: 2,
        showXAxis: false,
        showYAxis: false,
        borderWidth: 0,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingInner: 0,// 0.1
    }

    // NEXT: padding top to be complete 0 with a full width bar
    // with no spacing


    constructor(props) {
        super(props)

        const { dataset, superset,
                // eslint-disable-next-line                
                subset } = this.props
        this.dataset = dataset
        this.superset = superset
        
        log.trace("constructor(): dataset =", this.dataset)

        // we don't need to have those to be part of the state
        // cause it's chart-only
        this.showCircle = true

        this.state = {
            minX: 0
        }
        
    }

    handleChartClick = () => {
        // eslint-disable-next-line
        const { classes } = this.props

        log.trace("DashBar2Chart: handleChartClick(): this =", this)

        //        d3.select(this.refs.chartSvg).select(`#circle-1`)
        //        .classed(classes.removed, !this.showCircle)
        //        this.showCircle = !this.showCircle
        // this.setState({minX: this.state.minX + 1})
    }

    calcDims = () => {

        const { bar1Spacing,
                bar2Spacing,
                borderWidth,
                paddingTop, paddingRight, paddingBottom, paddingLeft, paddingInner
              } = this.props

        log.trace("DashBarChar: calcDims(): borderWidth =", borderWidth)
        
        let paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft, inner: paddingInner}
//        const paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft}
        //let margin = {top: 0, right: 0, bottom: 0, left: 0}

        // x-axis shows up in the bottom margin
        // top: works ok, just a bit of maring, but good for now
        // right: ok
        // bottom: the x-axis shows up in the bottom margin -ok
        // left: y-axis shows up on the left margin - ok
        // let margin = {top: 20,  right: 20, bottom: 30, left: 30}
        
        const chartDiv = d3.select(this.refs.chartDiv)
        const chartWidth = chartDiv.node().getBoundingClientRect().width
        const chartHeight = chartDiv.node().getBoundingClientRect().height
        const paintWidth = +chartWidth - paintMargin.left - paintMargin.right
        const paintHeight = +chartHeight - paintMargin.top - paintMargin.bottom

        this.dims = {
            chart: { // total chart div dimensions
                width: chartWidth,
                height: chartHeight
            },
            svg: { // svg tag size and other attributes
                width: chartWidth - borderWidth * 2,
                height: chartHeight - borderWidth * 2,
                viewBox: `0 0 ${chartWidth - borderWidth}px ${chartHeight - borderWidth}px`, // chartSvg
            },
            paint: { // actual paint sizes, this is what the transforms are made on
                width: paintWidth,
                height: paintHeight,
                margin: paintMargin
            },
            bar1: {
                spacing: bar1Spacing
            },
            bar2: {
                spacing: bar2Spacing
            },
            mark1: {
                width: 5,
                over: 5,
            },
            border: {
                width: borderWidth
            },
        }

        log.trace("DashBarChar: calcDims(): bar1Spacing =", bar1Spacing)
        log.trace("DashBarChar: calcDims(): this.dims =", this.dims)
        
    }


    drawChart = () => {

        // eslint-disable-next-line
        const { classes, showXAxis, showYAxis,
                showBar1, showBar2, showBar3,
                showMark1, chartBackgroundColor
              } = this.props

        log.trace("drawChart(): this.dataset =", this.dataset)
        log.trace("drawChart(): chartBackgroundColor =", chartBackgroundColor)

        this.calcDims()

        const chart = d3.select(this.refs.chartDiv)
        chart.style("border-width", `${this.dims.border.width}px`)
        chart.style("background-color", chartBackgroundColor)
        

        log.trace("drawChart(): this.dims.paint.width =", this.dims.paint.width)
        
        const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
//        x.domain([0,1000])

//        log.trace("drawChart(): x(0) =", x(0))
//        log.trace("drawChart(): x(1) =", x(200))

        
        //        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(0.1);
        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)

        // this domain and scale are chart based, not paint based ast for regular bars
        const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])
        const svg = d3.select(this.refs.chartSvg)
        log.trace("drawChart(): this.refs.chartSvg = ", this.refs.chartSvg)
        log.trace("drawChart(): svg = ", svg)

        svg
            .style("width", this.dims.svg.width)
            .style("height", this.dims.svg.height)
        

        // we are drawing this anew, so remove all the other g's there are
        // no updates yet.
        svg.selectAll("g").remove()
        const g = svg.append("g")
              .attr("transform", `translate(${this.dims.paint.margin.left},${this.dims.paint.margin.top})`)

        if(this.superset) {
            log.trace("DashBarChar: drawChart(): HAS superset")
        } else {
            log.trace("DashBarChar: drawChart(): NO superset")
        }
        
        if(this.superset) {
            x.domain([0,
                      // we can not have 0 here, max has to be at least 1
                      // for datasets with all 0's, be low will return "at least" 1
                      _.max([1,d3.max(this.superset, d => d.col1)]) // 
                     ])
        } else {
            x.domain([0, _.max(1,d3.max(this.dataset, d => d.col1))
                     ])
        }
        
        y.domain(this.dataset.map( d => {
            return d.name;
        }))

        yListener.domain(this.dataset.map( d => {
            return d.name;
        }))

        
        log.trace("DashBarChar: constructor(): this.dims.svgHeight =", this.dims.svgHeight)

         
        //https://github.com/d3/d3-axis#axis_tickValues
        //https://stackoverflow.com/questions/13100314/change-the-ticks-on-x-axis#13102118
        if(showXAxis) {
            g.append("g")
                .attr("class", classes.xAxis)
                .attr("transform", `translate(0,${this.dims.paint.height})`) // this transforms it vertical
                .call(d3.axisBottom(x).ticks(4))
            //.call(d3.axisBottom(x).tickValues(d3.range(0,10000,450))) // nice specific range starting with 0,range 450
        }

        if(showYAxis) {
            g.append("g")
                .attr("class", classes.yAxis)
                .call(d3.axisLeft(y))
        }

        if(showBar1) {
            // bar1 = col1, dark blue
            g.selectAll(".bar1")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", d => {
                    if(showBar3) {
                        return classes.bar3Negative
                    } else {
                        return classes.bar1
                    }
                })
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2)
                .attr("width", d => {
                    const widthValue = x(d.col1)
                    log.trace("drawChart(): d =",d)
                    log.trace("drawChart(): widthValue =", widthValue) // trace here why so high
                    return widthValue
                }
                     ) 
                .attr("height", y.bandwidth() - this.dims.bar1.spacing);
        }

        if(showBar3) {
            // bar3 positive
            g.selectAll(".bar3")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar3)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2)
                .attr("width", d => {
                    log.trace("drawChart(): bar3: d =", d)
                    log.trace("drawChart(): bar3: d.col3 =", d.col3)
                    const widthValue = x(d.col1 * d.col3) // total count * positive ratio
                    log.trace("drawChart(): bar3: widthValue =", widthValue) // trace here why so high
                    return widthValue
                }
                     ) 
                .attr("height", y.bandwidth() - this.dims.bar1.spacing);
        }
        

        if(showBar2) {
            // bar2 = col2, light blue
            g.selectAll(".bar2")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar2)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar2.spacing/2)
                .attr("width", d => x(d.col2))
                .attr("height", y.bandwidth() - this.dims.bar2.spacing)
        }


        // just a rectangle on top of everyting
        if(showBar1) {
            // bar1 = col1, dark blue
            g.selectAll(".bar1Rect")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", d => {
                        return classes.bar1Rect
                })
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2)
                .attr("width", d => {
                    const widthValue = x(d.col1)
                    log.trace("drawChart(): d =",d)
                    log.trace("drawChart(): widthValue =", widthValue) // trace here why so high
                    return widthValue
                }
                     ) 
                .attr("height", y.bandwidth() - this.dims.bar1.spacing);
        }


        if(showMark1) {
            log.trace("drawChart(): showMark1 =", showMark1)
            g.selectAll(".bar1Rect")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", d => {
                        return classes.mark1
                })
                .attr("x", d => x(d.mark1))
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2 - this.dims.mark1.over)
                .attr("width", d => {
                    return this.dims.mark1.width
                }) 
                .attr("height", d=> {
                    log.trace("drawChart(): showMark1: classes.mark1 =", classes.mark1)
                    return y.bandwidth() - this.dims.bar1.spacing + this.dims.mark1.over * 2
                })
        }

        
        // listener on top of bars, without zindex
        g.selectAll(".listener")
            .data(this.dataset)
            .enter().append("rect")
            .attr("class", classes.listener)
            .attr("x", -this.dims.paint.margin.left) // ignore the margin, all the way left
            .attr("y", d => yListener(d.name) - this.dims.paint.margin.top)
            .attr("width", this.dims.chart.width)
            .attr("height", yListener.bandwidth())
            // TODO: this overlap does not work for some reasons, but it does not make it worse :)
            //       we need to be able to overflow here over the border,
            // .attr("height", yListener.bandwidth() + 10) // NEXT: this is correct, continue here
            //.attr("height", "100%") // NEXT: this is correct, continue here        
            .on('mouseenter', (d,i) => {
                d3.event.stopPropagation()
                this.handleListenerMouseEnter(d,i)
            })
            .on('mouseleave', (d,i) => {
                d3.event.stopPropagation()
                this.handleListenerMouseExit(d,i)
            })
        
    }

    handleListenerMouseEnter = (d, i) => {
        log.trace("handleListenerMouseEnter(): d =", d)
        log.trace("handleListenerMouseEnter(): i =", i)

        const { onChartHover } = this.props
        if (onChartHover) onChartHover(d)

        // change the names from external tooltip root

//        const externalTooltip = true
//        const externalTooltipID = "externalTooltip"

        const { externalTooltip, externalTooltipID, externalTooltipRootID } = this.props
        
        let tooltip
        if(externalTooltip === true) {
            tooltip = d3.select(`#${externalTooltipID}`) // the tooltip for this canvas
            tooltip.style("display", "block")
        } else {
            tooltip = d3.select(this.refs.chartDiv).select("#tooltip") // the tooltip for this canvas
            tooltip.style("display", "block")
        }

        // tooltip.select("#name").text(d.name)
        tooltip.select("#count").text(`${d.col1}`)

        // this works: tooltip.select("#pro").text(`${Math.round(d.col3/d.col1 * 100)}%`)
        //this works: tooltip.select("#con").text(`${100 - Math.round(d.col3/d.col1 * 100)}%`)


        // here
        const pro = Math.round(d.col3 * 100)
        const proText = pro
        tooltip.select("#pro").text(`${proText}%`)

        const con = Math.round(100 - pro)
        const conText = con
        tooltip.select("#con").text(`${conText}%`)
        //        tooltip.select("#con").text("blah")
        


        
        /*
        tooltip.select("#pro").text(`${(d.col3 * 100)}%`)
        tooltip.select("#con").text(`${100 - (d.col3 * 100)}%`)
        */

        
        // tooltip.select("#pro").style("background-color", "#7db47b80")
        // tooltip.select("#con").style("background-color", "#ffeb3b80")

        //tooltip.select("#tooltipRow1").style("background-color", "#7db47b40")
        //tooltip.select("#tooltipRow2").style("background-color", "#ffeb3b40")

        //tooltip.select("#tooltipRow1").style("background-color", "#7db47b")
        //tooltip.select("#tooltipRow2").style("background-color", "#ffeb3b")

        
        /*
        const statesString = d.subset.map((ds, i) => `${ds.user.geo.state.code}`)
              .reduce((str, n) => {
                  if(!str)
                      return `${n}`
                  else
                      return str.includes(n) ? `${str}` : `${str},${n}`
              },'')
        tooltip.select("#states").text(`states: ${statesString}`)
        
        const uscdsString = d.subset.map((ds, i) => `${ds.user.geo.state.code}-${ds.user.geo.uscd.code}`)
        tooltip.select("#uscds").text(`uscds: ${uscdsString}`)
        */
        
        if(externalTooltip === true) {
            // set x,w
            const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
            const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)
            const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])

            if(this.superset) {
                x.domain([0, d3.max(this.superset, d => {
                    return d.col1;
                })])
            } else {
                x.domain([0, d3.max(this.dataset, d => {
                    return d.col1;
                })])
            }
            
            y.domain(this.dataset.map( d => {
                log.trace("DashBarChar: handleListenerMouseEnter: f2(): d.name =", d.name)
                return d.name;
            }))

            yListener.domain(this.dataset.map( d => {
                return d.name;
            }))


            //    const ty = y(d.name) + tooltip.node().getBoundingClientRect().width / 2
            const corrY = tooltip.node().getBoundingClientRect().height
            const corrX = tooltip.node().getBoundingClientRect().width

            const chart = d3.select(this.refs.chartDiv)
            const chartX = chart.node().getBoundingClientRect().x
            const chartY = chart.node().getBoundingClientRect().y
            
            log.trace("handleListenerMouseEnter(): chartX =", chartX)
            log.trace("handleListenerMouseEnter(): chartY =", chartY)

            // do the claculations with external tip root id

            const externalRoot = d3.select(`#${externalTooltipRootID}`)
            const externalRootX = externalRoot.node().getBoundingClientRect().x
            const externalRootY = externalRoot.node().getBoundingClientRect().y
            log.trace("handleListenerMouseEnter(): externalRootX =", externalRootX)
            log.trace("handleListenerMouseEnter(): externalRootY =", externalRootY)

            const rootYCorr = chartY - externalRootY
            const rootXCorr = chartX
            
            log.trace("handleListenerMouseEnter(): corrY =", corrY)
            log.trace("handleListenerMouseEnter(): corrX =", corrX)
            const tx = x(d.col1) - corrX/2 + this.dims.paint.margin.left - 5 + rootXCorr // pixels inside
            const ty = y(d.name) - corrY + y.bandwidth()/2 - this.dims.bar1.spacing/2 + rootYCorr

            // don't do transition the first time, where the tooltip is outside of the root
            log.trace("handleListenerMouseEnter(): first: x =", tooltip.node().getBoundingClientRect().x)
            log.trace("handleListenerMouseEnter(): first: chartX =", chartX)

            const { classes } = this.props
            
            if(tooltip.node().getBoundingClientRect().x < chartX) {
                log.trace("handleListenerMouseEnter(): first: setting first transition")
                // tooltip.style("transition", "sdf")
                tooltip.classed(classes.killTransition, true)
            } else {
                tooltip.classed(classes.killTransition, false)
            }
            
            tooltip.style("transform", `translate(${tx}px,${ty}px)`)
            
        } else {
            // set x,w
            const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
            const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)
            const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])

            if(this.superset) {
                x.domain([0, d3.max(this.superset, d => {
                    return d.col1;
                })])
            } else {
                x.domain([0, d3.max(this.dataset, d => {
                    return d.col1;
                })])
            }
            
            y.domain(this.dataset.map( d => {
                log.trace("DashBarChart: handleListenerMouseEnter: f2(): d.name =", d.name)
                return d.name;
            }))

            yListener.domain(this.dataset.map( d => {
                return d.name;
            }))


            //        const ty = y(d.name) + tooltip.node().getBoundingClientRect().width / 2
            const ycorr = tooltip.node().getBoundingClientRect().height
            const xcorr = tooltip.node().getBoundingClientRect().width
            log.trace("DashBarChar: handleListenerMouseEnter: ycorr =", ycorr)
            log.trace("DashBarChar: handleListenerMouseEnter: xcorr =", xcorr)
            const tx = x(d.col1) - xcorr/2 + this.dims.paint.margin.left - 5 // pixels inside
            const ty = y(d.name) - ycorr + y.bandwidth()/2 - this.dims.bar1.spacing/2
            tooltip.style("transform", `translate(${tx}px,${ty}px)`)
        }
    }

    handleListenerMouseExit = (data, index) => {
        log.trace("DashBarChar: handleListenerMouseExit(): data =", data)
        log.trace("DashBarChar: handleListenerMouseExit(): index =", index)

        const { externalTooltip, externalTooltipID } = this.props

        const { onChartUnhover } = this.props
        if (onChartUnhover) onChartUnhover(data)

        
        if(externalTooltip === true) {
            const tooltip = d3.select(`#${externalTooltipID}`) // the tooltip for this canvas
            tooltip.style("display", "none")
        } else {
            const tooltip = d3.select(this.refs.chartDiv).select("#tooltip") // the tooltip for this canvas
            tooltip.style("display", "none")
        }
    }

    componentDidUpdate(prevProps) {
        log.trace("componentDidUpdate(): prevProps.dataset =", prevProps.dataset)
        log.trace("componentDidUpdate(): this.props.dataset =", this.props.dataset)
        log.trace("componentDidUpdate(): this.props.chartBackgroundColor =", this.props.chartBackgroundColor)
        if(!_.isEqual(this.props.dataset, prevProps.dataset)) {
            log.trace("componentDidUpdate(): NEW DATASET")
            this.superset = this.props.superset
            this.dataset = this.props.dataset
            this.drawChart()
        }

        if(this.props.chartBackgroundColor !== prevProps.chartBackgroundColor) {
            const chart = d3.select(this.refs.chartDiv)

            log.trace("componentDidUpdate(): this.props.chartID =", this.props.chartID)
            log.trace("componentDidUpdate(): this.props.chartBackgroundColor =", this.props.chartBackgroundColor)

            const tryColor = this.props.chartBackgroundColor[this.props.chartID]

            log.trace("componentDidUpdate(): tryColor =", tryColor)
            
            if(tryColor) {
                chart.style("background-color", tryColor)
            } else {
                chart.style("background-color", "white")
            }

        }
    }


    componentDidMount() {
        log.trace("componentDidMount(): this.dataset =", this.dataset)
        log.trace("componentDidMount(): this.dataset.length =", this.dataset.length)
        
        // TODO: see what's really going on here
        if(this.dataset && this.dataset[0] && this.dataset.length > 0)
            this.drawChart()
    }
    
    render() {

        const { classes, dataset, chartID } = this.props

        log.trace("render(): dataset[0].column1.uuid =", dataset[0].column1.uuid)

	return (
            <div ref="chartDiv"
                 id={chartID}
                 className={classes.chartDiv} onClick={this.handleChartClick}>
              <div id="tooltip" className={classes.tooltip}>
                <div id="name">name</div>
                <div id="col1">count</div>
                <div id="states">states</div>
                <div id="uscds">uscds</div>
                <div className={classes.tooltipAnchor}></div>
              </div>
              <svg ref="chartSvg" id="chartSvg" className={classes.chartSvg}/>
            </div>
	)
    }

}

DashBar2Chart.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withStyles(styles, {name: "DashBar2Chart"})(DashBar2Chart)
